import { TerritoryRegion } from "@/data/territories";

export const LICENSE_TIERS = [
  {
    key: "instant",
    title: "Instant License",
    price: "$2,000 – $75,000",
    description:
      "Instant licensing for immediate use. License within minutes if you like the track.",
    badge: "Fastest clearance option",
    // Full Tailwind classes — JIT can't generate from template literals
    borderColor: "border-green-500",
    bgColor: "bg-green-500/5",
    badgeBg: "bg-green-500/10",
    textColor: "text-green-500",
  },
  {
    key: "standard",
    title: "Standard License",
    price: "$5,000 – $200,000",
    description:
      "Our benchmark licensing tier. Guaranteed review and approval within 3–5 business days.",
    badge: "Standard clearance process",
    borderColor: "border-blue-500",
    bgColor: "bg-blue-500/5",
    badgeBg: "bg-blue-500/10",
    textColor: "text-blue-500",
  },
  {
    key: "bespoke",
    title: "Bespoke Request",
    price: "Custom Pricing",
    description:
      "For complex clearances involving multiple publishers or unavailable artists. Extended timeline for big catalog songs.",
    badge: "Complex clearance process",
    borderColor: "border-amber-500",
    bgColor: "bg-amber-500/5",
    badgeBg: "bg-amber-500/10",
    textColor: "text-amber-500",
  },
] as const;

export type LicensingTierKey = "instant" | "standard" | "bespoke";

export const USAGE_TYPES = [
  "Commercial",
  "Broadcast",
  "Streaming",
  "Social Media",
  "Film/TV",
  "Games",
] as const;

export const COMMON_RESTRICTIONS = [
  "Political campaigns",
  "Adult content/Pornography",
  "War/Violence content",
  "Tobacco advertising",
  "Gambling/Betting",
  "Weapons/Firearms",
  "Hate speech",
  "Illegal activities",
  "Competing artists",
  "Religious content",
] as const;

export const REGION_ORDER: TerritoryRegion[] = [
  "EU",
  "UK",
  "NA",
  "LATAM",
  "SA",
  "AFRICA",
  "MEENA",
  "APAC",
];

export const MAX_VISIBLE_TERRITORIES = 5;

export const normalizeTerritories = (value: any): string[] => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value
      .map((item) => (typeof item === "string" ? item : String(item)))
      .filter(Boolean);
  }
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed
          .map((item) => (typeof item === "string" ? item : String(item)))
          .filter(Boolean);
      }
    } catch {
      return value
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    }
    return value ? [value] : [];
  }
  return [];
};
